<div class="app-titulo-pagina">
    <span>Nova Transferência Bancária</span>
</div>
<div class="container">

    <div *ngIf="processando" class="text-center">
        <i class="fa fa-spinner fa-pulse fa-4x"></i>
    </div>

    <article *ngIf="!processando" class="col-xs-12 col-md-10 col-md-offset-1 app-msg-transf">
        <h4>
            Com o PicPontos você pode transferir seus pontos diretamente para qualquer conta bancária.
        </h4>
    </article>

    <form *ngIf="!processando" ngNativeValidate (submit)="saveBancaria()" class="col-xs-12 col-md-10 col-md-offset-1 ">
        <div class="panel panel-default">
            <div class="panel panel-heading">
                <label>Dados do Favorecido</label>
            </div>

            <div class="panel-body">

                <div *ngIf="contasValidas === undefined" class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-4x"></i>
                </div>

                <div class="form-group" *ngIf="contasValidas.length">

                    <div class="col-xs-12">
                        <label for="favorecidos">Histórico de Contas</label>
                        <select class="form-control input-sm app-favorecidos-validos" id="favorecidos"
                            name="transferenciaSelect" [(ngModel)]="contaRecebida" (ngModelChange)="selecionarConta()"
                            required>
                            <option *ngFor="let contaRecebida of contasValidas" [ngValue]="contaRecebida" name="conta">
                                {{ contaRecebida.banco.codigo + ' - ' + contaRecebida.banco.apelido + ' ' + ' | Agência: ' + contaRecebida.agencia +
                                (contaRecebida.agenciaDigito != undefined ? '-'+contaRecebida.agenciaDigito:"" ) + ' | Conta: ' + contaRecebida.numero +
                                '-' + contaRecebida.numeroDigito + ' | '  + (contaRecebida.poupanca ? 'Conta Poupança' :'Conta Corrente')  }}
                            </option>
                            <option [value]="">Nova Conta</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label for="titular">Nome Completo</label>
                    <input type="text" id="titular" [(ngModel)]="conta.titularNome" name="titularNome"
                        class="form-control input-sm" maxlength="256" [readonly]="inputReady" required>
                </div>
                <div class="form-group">
                    <label for="documento">Documento</label>
                    <div class="input-group">
                        <div class="input-group-btn">
                            <button id="botaoCpfTransferencia" type="button" class="btn btn-sm"
                                [ngClass]="{ 'app-btn-best': documentoTipo === 'CPF' }"
                                (click)=" documentoTipo = 'CPF' " [disabled]="inputReady">
                                <i [ngClass]="{ 'fa fa-check': documentoTipo === 'CPF' }"></i> CPF
                            </button>
                            <button id="botaoCnpjTransferencia" type="button" class="btn btn-sm "
                                [ngClass]="{ 'app-btn-best': documentoTipo === 'CNPJ' }"
                                (click)=" documentoTipo = 'CNPJ'" [disabled]="inputReady">
                                <i [ngClass]="{ 'fa fa-check': documentoTipo === 'CNPJ' }"></i> CNPJ
                            </button>
                        </div>
                        <input type="text" id="documento" class="form-control input-sm"
                            name="conta-titular-documentoCPF" [(ngModel)]="conta.titularDocumento"
                            *ngIf="documentoTipo === 'CPF'" [readonly]="inputReady" required UiCpf>
                        <input type="text" id="documento" class="form-control input-sm"
                            name="conta-titular-documentoCNPJ" [(ngModel)]="conta.titularDocumento"
                            *ngIf="documentoTipo === 'CNPJ'" [readonly]="inputReady" UiCnpj required>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-xs-12">
                        <label for="banco">Banco</label>
                        <select class="form-control input-sm" id="banco" name="banco"
                            [ngModel]="isFavorecido() ? conta.banco : conta.banco.codigo"
                            (ngModelChange)="setAccount($event)" [disabled]="inputReady" required>
                            <option value=""></option>
                            <option *ngFor=" let banco of bancos " [ngValue]="isFavorecido() ? banco : banco.codigo"
                                name="BancoId" id="{{ 'banco-' + banco }} ">
                                {{ banco.codigo + ' - ' + banco.nome }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-xs-8 col-md-5">
                        <label for="agencia">Agência</label>
                        <input type="text" id="agencia" name="conta-agencia" [(ngModel)]="conta.agencia"
                            [readonly]="inputReady" UiNumeros class="form-control input-sm" maxlength="4" required>
                    </div>
                    <div class="col-xs-4 col-md-1">
                        <label for="agenciaDigito">Dígito</label>
                        <input type="text" id="agenciaDigito" name="conta-agencia-digito"
                            [(ngModel)]="conta.agenciaDigito" [readonly]="inputReady" UiNumeros
                            class="form-control input-sm" maxlength="1">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-xs-8 col-md-5">
                        <label for="conta">Conta</label>
                        <input type="text" id="conta" name="conta-numero" [(ngModel)]="conta.numero"
                            [readonly]="inputReady" UiNumeros class="form-control input-sm" maxlength="12" required>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-4 col-md-1">
                            <label for="contaDigito">Dígito</label>
                            <input type="text" id="contaDigito" name="conta-numeroDigito"
                                [(ngModel)]="conta.numeroDigito" [readonly]="inputReady" UiContaBancariaNumeroDigito
                                class="form-control input-sm" maxlength="1" required>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <input type="radio" id="correnteBotao" name="tipoconta" [(ngModel)]="conta.poupanca" [value]="false"
                        [disabled]="inputReady" required><label for="correnteBotao"> Corrente</label>&nbsp;
                    <input type="radio" name="tipoconta" id="poupancaBotao" [(ngModel)]="conta.poupanca"
                        [disabled]="inputReady" [value]="true" required><label for="poupancaBotao"> Poupança</label>
                </div>

                <div class="col-xs-12"
                    *ngIf="conta.titularNome && conta.titularDocumento && conta.banco && conta.agencia && conta.numero && conta.numeroDigito">
                    <div class="col-xs-12 col-md-6 ">
                        <label for="tarifa">Valor da tarifa de DOC/TED em Pontos</label>
                        <input type="text" id="tarifa" class="form-control input-sm" value="{{ tarifa }}" readonly>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <label for="valor">Valor total do debito em pontos </label>
                        <input type="text" id="valor" class="form-control input-sm" value="{{ valorPontos }}" readonly>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <label for="valorLiquido">Valor liquido a ser transferido em Moeda</label>
                        <div class="input-group">
                            <span class="input-group-addon" id="basic-addon1">R$</span>
                            <input id="valorLiquido" type="text" maxlength="8" class="form-control input-sm"
                                name="valorMoeda" [(ngModel)]="conta.valorMoeda" (focusout)="calculaValorPontos()"
                                uiMoeda required>
                        </div>
                        <span class="help-block"><small>Formato: 100.50</small></span>
                    </div>
                    <div class="col-xs-12 col-md-6 form-group">
                        <label for="epwd">Senha eletrônica </label>
                        <input type="password" id="epwd" name="epwd" class="form-control input-sm" [(ngModel)]="epwd"
                            [required]>
                    </div>
                </div>
                <div class="col-xs-12 text-left">
                    <div class="alert alert-warning" role="alert">
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Transferências realizadas após
                            às 15:30 horas ficarão agendadas para o processamento do dia útil seguinte e disponível na
                            conta em até 48 horas.</p>
                        <br />
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Solicitações feitas em finais
                            de semana e/ou feriados serão agendadas para o próximo dia útil.</p>
                        <br>
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Não serão permitidas
                            transferências para contas Conjunta ou Salário.</p>
                        <br>
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <strong>Não</strong> serão permitidas
                            transferências para contas de <strong>terceiros</strong>.</p>
                        <br>
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Não colocar dígito na agência
                            em contas do Banco do Brasil.</p>
                        <br>
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Conta mista(Corrente e
                            Poupança): o crédito será direcionado sempre para a conta corrente. Para crédito em conta
                            Poupança, esta, deverá ser exclusivamente poupança.</p>
                        <br>
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Haverá nova cobrança de taxa se
                            os dados bancários estiverem incorretos. Portanto, verifique se os dados do titular da conta
                            (Nome e CPF) e os dados bancários do favorecido(Banco, Agência e Conta Corrente/Poupança)
                            estão corretos.</p>
                        <br>
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> O valor mínimo para
                            transferência
                            <strong>{{ limiteMinimoTransferencia | currency:'BRL':'symbol':'1.2-2':'pt' }}</strong> (por
                            solicitação).
                        </p>
                        <br>
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> O valor máximo para
                            transferência é de
                            <strong>{{ limiteMaximoTransferencia | currency:'BRL':'symbol':'1.2-2':'pt' }}</strong> (por
                            solicitação).
                        </p>
                        <br>
                        <!-- <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> O limite máximo
                            <strong>diário</strong> para
                            transferências é de
                            <strong>{{ limiteMaximoTransferencia | currency:'BRL':'symbol':'1.2-2':'pt' }}</strong>.
                        </p>
                        <br> -->
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <strong>Taxa de serviço:
                                {{ tarifaBancaria }} pontos.</strong> A Tarifa está sujeita à alteração sem aviso
                            prévio pela instituição financeira.</p>
                    </div>
                </div>
                <div class="text-center" style="margin-top: 2em;">
                    <a id="btn-voltar" (click)="mainService.loginService.changeRoute('transferencias')"
                        class="btn btn-danger-v2">
                        Voltar
                    </a>
                    <button id="confirmar-transferencia" [disabled]="!epwd" type="submit" class="btn btn-success-v2">
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>


// WEBPACK FOOTER //
// ./src/app/transferencia/bancaria/bancaria.component.html